<template>
  <div class="width100 margin-auto">
    <!-- 头部 -->
    <!-- 内容· -->
    <div class="backwhite width98 margin-auto">
      <div class="pad-bot20 f16 width98 textalign-left dimensional">
        新增研发费用
      </div>
      <!-- 内容表单 -->
      <div class="width100">
        <div class="width100 textalign-left">
          <p class="lineheight30">所属项目</p>
          <div class="width100" @click="drawershare = true">
            <el-input
              placeholder="请选择研发项目"
              :readonly="true"
              v-model="proid"
            />
          </div>
        </div>
        <div
          class="acceptancecomments f12 border-rd3"
          style="color: #969eac"
          v-if="proid"
        >
          <p class="width98 margin-auto flex-betweenwrap">
            <span class="width40 textalign-left">项目名称：{{ protitle }}</span
            ><span class="width20 textalign-left"
              >项目编号: {{ pronumber }}</span
            ><span class="width20 textalign-left">
              立项时间: {{ protime }}</span
            >
            <span class="width20 textalign-left">
              研发阶段: {{ progress }}</span
            >
          </p>
          <p class="width98 margin-auto flex-betweenwrap">
            <span class="width40 textalign-left"
              >项目负责人：{{ promanager }}</span
            ><span class="width20 textalign-left"
              >承担部门：{{ proresearch }}</span
            >
            <span class="width20 textalign-left"
              >协作单位：{{ procooperation }}</span
            >
            <span class="width20 textalign-left"> </span>
          </p>
        </div>
        <div class="width100 margin-top10 textalign-left">
          <p class="lineheight30 pad-right10">费用类型</p>
          <div class="width100 flex-betweenwrap">
            <el-select
              v-model="fee_type"
              class="width48"
              placeholder="请选择费用类型"
              @change="feetype"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                class="width100"
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              class="width48"
              v-model="smallfee_type"
              placeholder="请选择费用类型"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                class="width100"
                v-for="item in smalloptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :filterable="true"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="invoice width98 margin-auto" v-if="proid">
          <p class="f14 margin-top20" style="color: #6a7589">
            {{ companytitle }}
          </p>
          <p class="f24 margin-top10 dimensional">
            《{{ protitle }}》研发项目经费报销单
          </p>
          <p
            class="width96 margin-auto flex-betweenwrap margin-top20"
            style="color: #6a7589"
          >
            <span
              >报销人：<span v-if="authority == 2"> {{ realnamepro }}</span>
              <el-select
                v-if="authority != 2"
                v-model="realnamepro"
                placeholder="请选择报销人"
                :filterable="true"
              >
                <el-option label="---  请选择  ---" value=""></el-option>
                <el-option
                  v-for="item in reimpipo"
                  :key="item.user_id"
                  :label="item.realname"
                  :value="item.user_id"
                >
                </el-option>
              </el-select> </span
            ><span
              >报销日期 : <span v-if="authority == 2"> {{ proddtime }}</span>
              <el-date-picker
                v-if="authority != 2"
                v-model="proddtime"
                style="width: 60%"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker
            ></span>
            <span>单位:元</span>
          </p>
          <div class="width96 margin-auto margin-top10">
            <div class="textalign-left">
              <p style="color: #6a7589">报销内容</p>
              <el-input
                type="textarea"
                :autosize="autosize"
                placeholder="请输入报销内容"
                v-model="reimbursement"
              />
            </div>
          </div>
          <div class="width96 margin-auto margin-top10">
            <div class="textalign-left">
              <p style="color: #6a7589">报销金额</p>
              <el-input
                type="number"
                placeholder="请输入报销金额"
                v-model="reimbursementmoney"
                @input="moneychange"
              />
            </div>
          </div>
          <p
            class="width96 margin-auto textalign-left pad-top10"
            style="color: #6a7589"
          >
            人民币大写：{{ bigmoney }}
          </p>
          <div
            class="
              width96
              margin-auto
              f12
              margin-top10
              pad-top10 pad-bot20
              textalign-left
            "
            style="border-top: 1px dashed #52c5cb"
          >
            <div
              class="width100 border-rd3 flex-betweencen margin-top10"
              style="min-height: 35px"
              v-for="(item, index) in filearr"
              :key="index"
            >
              <span @click="seafile(item)" style="color: #2f6cff"
                >附件： {{ item.data.original_name }}</span
              >

              <span
                @click="situationfilesremove(index)"
                class="pad-right10 cursorpointer"
              >
                <span><img src="@/assets/barsvg/icon／12sc.png" alt="" /></span>
              </span>
            </div>
            <div class="approvebtns margin-top20">
              <el-upload
                class="avatar-uploader"
                :action="Apisrc"
                name="file"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleerror"
                :data="user"
                :headers="head"
              >
                <el-button>添加附件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button class="margin-top20" type="primary" @click="Savechanges()">
          确定
        </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="drawershare"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorboxs"
    >
      <div class="newenterprise">
        <div class="width99 margin-auto margin-top20">
          <div class="width99 margin-auto quickbtns f14 formitemlabel">
            <span class="pad-left10"></span>
            项目名称 :
            <input
              class="width50 searchinput"
              v-model="pronameinput"
              placeholder="  请输入内容"
            />
            <el-button
              type="primary"
              size="mini"
              class="hight30 margin-left10"
              @click="submitForm()"
              >检 索</el-button
            >
            <el-button class="hight30" size="mini" @click="resetForm()"
              >重 置</el-button
            >
          </div>
          <div
            class="
              flex-around
              width99
              margin-auto margin-top20
              hight40
              lineheight40
              f14
              backef
              borderb
              textalign-left
            "
          >
            <span class="width40 pad-left20">项目名称</span
            ><span class="width20">项目编号</span
            ><span class="width25">项目负责人</span>
          </div>
          <div
            class="
              flex-around
              f12
              width100
              borderbbb
              hovercont
              textalign-left
              lineheight35
            "
            v-for="(item, index) in nullcont"
            :key="index"
            @click="coerchange(index)"
          >
            <span class="width40 pad-left20">{{ item.title }}</span
            ><span class="width20">{{ item.project_number }}</span
            ><span class="width25">{{ item.manager_name }}</span>
          </div>
        </div>
      </div>
      <div class="flex-betweennowrap pad-top20 pagination">
        <span></span>
        <!-- 分页 -->
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="currentchange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
import {
  entrdfeesave,
  entrdfeecate,
  enttechresearchdevelopmentmy,
} from "@/api/newhead/newhead.api";
import { pipoList } from "@/api/Center/Center.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      proid: "",
      protitle: "",
      pronumber: "",
      protime: "",
      progress: "",
      promanager: "",
      proresearch: "",
      procooperation: "",
      fee_type: "",
      options: [],
      smalloptions: [],
      smallfee_type: "",
      companytitle: "",
      prodatatime: "",
      reimbursement: "",
      reimbursementmoney: "",
      bigmoney: "",
      user: {
        project_id: "",
        // value_id: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      filearr: [],
      fileid: [],
      proddtime: "",
      pronameinput: "",

      str: "",
      title: "",
      year: "",
      payee: "",
      parter: "",
      amount: "",
      pay_date: "",
      file: "",
      remark: "",
      voucher: "",
      fund: "",
      id: "",
      projectName: "",
      num: 200,

      page: "",
      responseid: "",
      Apisrc: "",
      drawershare: false,
      directionshare: "btt",
      titlespanshare: "",
      input3: "",
      nullcont: [],
      radio: "",
      changeid: "",

      limit: "",

      currentPage: 1,
      total: 0,
      per_page: "",

      userpeple: "",
      realnamepro: "",
      reimpipo: [],
      authority: "",
    };
  },

  methods: {
    submitForm() {
      if (this.pronameinput != "") {
        // 获取研发项目
        enttechresearchdevelopmentmy({ _keywords: this.pronameinput }).then(
          (res) => {
            if (res.data.code == 200) {
              this.nullcont = res.data.data.data;
              this.total = res.data.data.total;
              this.per_page = res.data.data.per_page;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          }
        );
      }
    },
    // input重 置
    resetForm() {
      this.pronameinput = null;
      enttechresearchdevelopmentmy({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.nullcont = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    monitorInput() {
      var txtVal = this.remark.length;
      this.num = 200 - txtVal;
    },
    // 第一个分页
    currentchange(val) {
      enttechresearchdevelopmentmy({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.nullcont = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      enttechresearchdevelopmentmy({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.nullcont = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    oninput() {
      if (this.input3 != "") {
        enttechresearchdevelopmentmy({ page: this.thisNum }).then((res) => {
          if (res.data.code == 200) {
            this.nullcont = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        enttechresearchdevelopmentmy({ page: this.thisNum }).then((res) => {
          if (res.data.code == 200) {
            this.nullcont = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    coerchange(val) {
      if (this.authority == 2) {
        var d = new Date();
        var m = d.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var date = d.getDate();
        date = date < 10 ? "0" + date : date;
        this.prodatatime = d.getFullYear() + " 年" + m + " 月" + date + " 日";
        this.proddtime = d.getFullYear() + "-" + m + "-" + date;
        this.realnamepro = window.sessionStorage.getItem("realname");
      }
      pipoList({ dev_project_id: this.nullcont[val].id }).then((res) => {
        if (res.data.code == 200) {
          this.reimpipo = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
      this.changeid = this.nullcont[val].id;
      this.proid = this.nullcont[val].title;
      this.drawershare = false;
      this.protitle = this.nullcont[val].title;
      this.pronumber = this.nullcont[val].project_number;
      this.protime = this.nullcont[val].start_date;
      this.progress = this.nullcont[val].progress_text;
      this.promanager = this.nullcont[val].manager_name;
      this.proresearch = this.nullcont[val].research_dev_title;
      this.procooperation = this.nullcont[val].cooperation;
      this.user.project_id = this.nullcont[val].id;
    },
    feetype(e) {
      this.smallfee_type = "";
      entrdfeecate({ parent_id: e }).then((res) => {
        if (res.data.code == 200) {
          this.smalloptions = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    moneychange(str) {
      var num = parseFloat(str);
      var strOutput = "",
        strUnit = "仟佰拾亿仟佰拾万仟佰拾元角分";
      num += "00";
      var intPos = num.indexOf(".");
      if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
      }
      strUnit = strUnit.substr(strUnit.length - num.length);
      for (var i = 0; i < num.length; i++) {
        strOutput +=
          "零壹贰叁肆伍陆柒捌玖".substr(num.substr(i, 1), 1) +
          strUnit.substr(i, 1);
      }
      strOutput
        .replace(/零角零分$/, "整")
        .replace(/零[仟佰拾]/g, "零")
        .replace(/零{2,}/g, "零")
        .replace(/零([亿|万])/g, "$1")
        .replace(/零+元/, "元")
        .replace(/亿零{0,3}万/, "亿")
        .replace(/^元/, "零元");

      this.bigmoney = strOutput;
    },
    // 上传
    beforeUpload(file) {
      this.head.token = window.sessionStorage.getItem("token");
      this.$loadings.show(); // 显示loading
    },
    handleprogress(file, fileList) {
      this.user.filename = fileList.name;
    },

    handleAvatarSuccess(response, file, fileList) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.responseid = response.data.id;
        this.voucher = response.data.url;
        this.fund = file.name;
        this.$loadings.hide(); // 隐藏loading
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.filearr.push(file.response);
        this.fileid.push(file.response.data.id);
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.imgNum}个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    onchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    situationfilesremove(index) {
      this.filearr.splice(index, 1);
    },

    Savechanges() {
      entrdfeesave({
        project_id: this.changeid,
        detail: this.reimbursement,
        amount: this.reimbursementmoney,
        category: this.fee_type,
        class: this.smallfee_type,
        pay_date: this.proddtime,
        user_id: this.realnamepro,
        // title: "费用名称",
        // remark: "备注",
        files: this.fileid, //附件ID
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.changeid = "";
          this.reimbursement = "";
          this.reimbursementmoney = "";
          this.fee_type = "";
          this.smallfee_type = "";
          this.proid = "";
          BUS.$emit("collectionadd", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialognull() {
      BUS.$emit("collectionadd", "yess");
    },
  },

  created() {
    this.authority = window.sessionStorage.getItem("authority");
    this.Apisrc = window.g.ApiUrl + "/ent_rd_fee/uploader";
    this.limit = window.g.imgNum;
    this.companytitle = window.sessionStorage.getItem("companytitle");
    // 获取研发项目
    enttechresearchdevelopmentmy({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.nullcont = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    entrdfeecate({}).then((res) => {
      if (res.data.code == 200) {
        this.options = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>
    
<style scoped>
.numLimit {
  position: relative;
  top: 40px;
  left: 20px;
  font-size: 14px;
  color: #a4adb3;
}
::placeholder {
  color: #a4a4a4;
}
.newenterprise {
  width: 98%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  line-height: 35px;
  color: #767676;
  /* border-bottom: 1px solid #efefef; */
  font-size: 14px;
  padding: 0 10px 0 10px;
}
.hovercont:hover {
  background: #ecf8f9;
}
.linkfile:hover {
  border-bottom: 1px solid #52c5cb;
}
.el-input {
  width: 100%;
}
.acceptancecomments {
  width: 99%;
  line-height: 30px;
  padding-left: 10px;
  margin: 20px 0 0 0;
  background-color: #f6f7fb;
  /* border: 1px solid rgba(187, 187, 187, 1); */
}
.invoice {
  width: 100%;
  line-height: 30px;
  border-radius: 3px;
  margin: 30px 0 0 0;
  background: #ecf8f9;
  border: 1px dashed #52c5cb;
}

.inputinner >>> .el-input__inner {
  border: none;
}
.inputinner >>> .el-button {
  border: none;
}
.coer {
  width: 15px;
  overflow: hidden;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
</style>
    